import { gql, Apollo } from '@thriveglobal/thrive-web-core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>
}
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string
    String: string
    Boolean: boolean
    Int: number
    Float: number
    Instant: any
    UUID: any
}

export enum Auth {
    ApiAdmin = 'ApiAdmin',
    AzureAd = 'AzureAD',
    Cognito = 'Cognito',
    Genesys = 'Genesys',
    GenesysUsEast1 = 'GenesysUsEast1',
    GenesysUsWest2 = 'GenesysUsWest2',
    HumanApi = 'HumanAPI',
    Impersonation = 'Impersonation',
    Okta = 'Okta',
    OktaZp = 'OktaZp',
    Partner = 'Partner',
    RefreshToken = 'RefreshToken',
    Slack = 'Slack'
}

export type Brand = {
    __typename?: 'Brand'
    companyId: Scalars['UUID']
    createdAt: Scalars['Instant']
    imageUrl?: Maybe<Scalars['String']>
    isPublic: Scalars['Boolean']
    name: Scalars['String']
    updatedAt: Scalars['Instant']
}

export type Company = {
    __typename?: 'Company'
    brands: Array<Brand>
    configuration: Scalars['String']
    id: Scalars['UUID']
    imageUrl?: Maybe<Scalars['String']>
    isPublic: Scalars['Boolean']
    name: Scalars['String']
    status: CompanyStatus
}

export type CompanyPage = {
    __typename?: 'CompanyPage'
    items: Array<Company>
    itemsPerPage: Scalars['Int']
    page: Scalars['Int']
    total: Scalars['Int']
}

export type CompanySearchResult = {
    __typename?: 'CompanySearchResult'
    quality: Scalars['Float']
    result: Company
}

export type CompanySearchResultPage = {
    __typename?: 'CompanySearchResultPage'
    items: Array<CompanySearchResult>
    itemsPerPage: Scalars['Int']
    page: Scalars['Int']
    total: Scalars['Int']
}

export enum CompanyStatus {
    Active = 'active',
    Demo = 'demo',
    Inactive = 'inactive',
    Prospect = 'prospect',
    Test = 'test'
}

export enum CustomFieldI18nId {
    EmployeeId = 'employeeId',
    FacilityNumber = 'facilityNumber',
    GroupCode = 'groupCode',
    ZipCode = 'zipCode'
}

export type CustomFieldIdpMappings = {
    __typename?: 'CustomFieldIdpMappings'
    i18nId: CustomFieldI18nId
    idpMappings: Array<IdpCustomField>
    keycloakFieldName?: Maybe<Scalars['String']>
}

export enum ErrorCode {
    IdentityTokenErrorEmailOwnedByAnotherCompany = 'IDENTITY_TOKEN_ERROR_EMAIL_OWNED_BY_ANOTHER_COMPANY',
    IdentityTokenErrorExternalIdpFailure = 'IDENTITY_TOKEN_ERROR_EXTERNAL_IDP_FAILURE',
    IdentityTokenErrorMalformedEmail = 'IDENTITY_TOKEN_ERROR_MALFORMED_EMAIL',
    IdentityTokenErrorNotAllowed = 'IDENTITY_TOKEN_ERROR_NOT_ALLOWED',
    IdentityTokenErrorReferralsDisabled = 'IDENTITY_TOKEN_ERROR_REFERRALS_DISABLED',
    IdentityTokenErrorReferralRequired = 'IDENTITY_TOKEN_ERROR_REFERRAL_REQUIRED',
    IdentityTokenErrorSubscriptionDisabled = 'IDENTITY_TOKEN_ERROR_SUBSCRIPTION_DISABLED',
    IdentityTokenErrorUnexpected = 'IDENTITY_TOKEN_ERROR_UNEXPECTED',
    IdentityTokenErrorUserAlreadyExists = 'IDENTITY_TOKEN_ERROR_USER_ALREADY_EXISTS',
    IdentityTokenErrorUserNotFound = 'IDENTITY_TOKEN_ERROR_USER_NOT_FOUND',
    IdentityTokenErrorWrongSignupCode = 'IDENTITY_TOKEN_ERROR_WRONG_SIGNUP_CODE'
}

export enum GenesysRegion {
    ApNortheast_1 = 'AP_NORTHEAST_1',
    ApNortheast_2 = 'AP_NORTHEAST_2',
    ApSoutheast_2 = 'AP_SOUTHEAST_2',
    ApSouth_1 = 'AP_SOUTH_1',
    CaCentral_1 = 'CA_CENTRAL_1',
    EuCentral_1 = 'EU_CENTRAL_1',
    EuWest_1 = 'EU_WEST_1',
    EuWest_2 = 'EU_WEST_2',
    UsEast_1 = 'US_EAST_1',
    UsEast_2 = 'US_EAST_2',
    UsWest_2 = 'US_WEST_2'
}

export type IdpConfig = {
    __typename?: 'IdpConfig'
    companyId: Scalars['UUID']
    configuration: Scalars['String']
    emailAllowList: Array<Scalars['String']>
    enabled: Scalars['Boolean']
    id: Scalars['UUID']
    idpCompanyId?: Maybe<Scalars['String']>
    idpType: Scalars['String']
    loginMethod: Scalars['String']
}

export type IdpConfigFiltersInput = {
    enabled?: InputMaybe<Scalars['Boolean']>
    idpTypeAllowlist?: InputMaybe<Array<IdpType>>
}

export type IdpConfigPage = {
    __typename?: 'IdpConfigPage'
    items: Array<IdpConfig>
    itemsPerPage: Scalars['Int']
    page: Scalars['Int']
    total: Scalars['Int']
}

export type IdpConfigsForUserPage = {
    __typename?: 'IdpConfigsForUserPage'
    items: Array<IdpConfig>
    itemsPerPage: Scalars['Int']
    page: Scalars['Int']
    total: Scalars['Int']
    userIdpTypes: Array<IdpType>
}

export type IdpCustomField = {
    __typename?: 'IdpCustomField'
    fieldName: Scalars['String']
    idpType: IdpType
}

export enum IdpType {
    Awscognito = 'awscognito',
    Azuread = 'azuread',
    Genesys = 'genesys',
    GenesysUsEast_1 = 'genesys_us_east_1',
    GenesysUsWest_2 = 'genesys_us_west_2',
    HumanApi = 'human_api',
    KeycloakDirectPassword = 'keycloak_direct_password',
    KeycloakDirectWebauthn = 'keycloak_direct_webauthn',
    KeycloakOktaSso = 'keycloak_okta_sso',
    KeycloakSso = 'keycloak_sso',
    KeycloakTokenExchange = 'keycloak_token_exchange',
    Magiclink = 'magiclink',
    Nice = 'nice',
    Okta = 'okta',
    OktaZp = 'okta_zp',
    Partner = 'partner',
    Slack = 'slack',
    Webex = 'webex',
    WebexTst = 'webex_tst',
    Zoom = 'zoom'
}

export type KeycloakAuthResponse = {
    __typename?: 'KeycloakAuthResponse'
    accessToken: Scalars['String']
    expiresIn: Scalars['String']
    idToken?: Maybe<Scalars['String']>
    refreshToken?: Maybe<Scalars['String']>
}

export type LogMeWithMutation = {
    __typename?: 'LogMeWithMutation'
    /** Exchanges AzureAD token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    azureAd: TokenResponse
    /** Exchanges AzureAD token to Thrive Keycloak token. Issuer must be whitelisted through IDP configs */
    azureAdKeycloak: KeycloakAuthResponse
    /** Exchanges Cognito token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    cognito: TokenResponse
    /** Exchanges Genesys token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    genesys: TokenResponse
    /** Exchanges Human API token to Thrive Identity token */
    humanApi: TokenResponse
    /** Exchanges Okta (SSO) token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    okta: TokenResponse
    /** Exchanges OktaZP token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    oktaZp: TokenResponse
    /** Exchanges partner token from header and userId in arguments to Thrive Identity token. Company name from partner token must be whitelisted through IDP configs */
    partner: TokenResponse
    /** Exchanges Slack token to Thrive Identity token. Issuer must be whitelisted through IDP configs */
    slack: TokenResponse
}

export type LogMeWithMutationGenesysArgs = {
    region: GenesysRegion
}

export type LogMeWithMutationPartnerArgs = {
    userId: Scalars['String']
}

export type MagicLinkCacheResponse = {
    __typename?: 'MagicLinkCacheResponse'
    cacheId: Scalars['UUID']
    expiration?: Maybe<Scalars['Instant']>
    magicLink?: Maybe<Scalars['String']>
    redirectUrl?: Maybe<Scalars['String']>
    userId: Scalars['UUID']
}

export type MagicLinkRequestInput = {
    clientId?: InputMaybe<Scalars['String']>
    email: Scalars['String']
    redirectUrl?: InputMaybe<Scalars['String']>
    state?: InputMaybe<Scalars['String']>
}

export type Mutation = {
    __typename?: 'Mutation'
    /** Set of mutations to exchange your external IDP tokens to Thrive Identity token */
    logMeWith: LogMeWithMutation
    /** Send magic link to email to login without password. State parameter will be returned in a link as query parameter as is. Returns true if email is sent */
    magicLink: Scalars['Boolean']
}

export type MutationMagicLinkArgs = {
    input: MagicLinkRequestInput
}

export type Query = {
    __typename?: 'Query'
    /** Returns all public companies with optional pagination */
    getCompanies: CompanyPage
    /** Returns company privacy policy, lookup is by IDP ID */
    getCompanyPolicyByIdp: Scalars['Boolean']
    /** Returns public configuration options for given company by Thrive company ID */
    getCompanyTermsOfService: Array<TermsOfServiceOption>
    /** Returns the country code sent by cloudflare */
    getCountryCodeHeader?: Maybe<Scalars['String']>
    /** Returns the mappings for custom fields in different IDPs */
    getCustomFieldMappings: Array<CustomFieldIdpMappings>
    /** Returns all idp configs with optional pagination with exact match for a given company or brand */
    getIdpConfigs: IdpConfigPage
    /** Returns all idp configs with optional pagination with exact match for a given company */
    getIdpConfigsByCompanyId: IdpConfigPage
    /**
     * Returns all idp configs with optional pagination for a given user email
     * @deprecated Moving to a more flexible query, replace with getIdpConfigsForUserByEmail
     */
    getIdpConfigsByEmail: IdpConfigPage
    /** Returns all idp configs with optional pagination for a given user email */
    getIdpConfigsForUserByEmail: IdpConfigsForUserPage
    /** Returns a magic link from the cache whe provided with a valid user ID and cache ID */
    getMagicLink: MagicLinkCacheResponse
    /** Returns all companies (including private) with optional pagination with fuzzy match for a given company or brand */
    getSimilarCompanies: CompanySearchResultPage
    /** Returns true if user accepted TOS otherwise false, lookup is by IDP ID */
    getUserPolicyByIdp: Scalars['Boolean']
    /** Returns whether an invite is still valid */
    isInviteValid: Scalars['Boolean']
    /** Validates the group code and email to ensure user can sign up (note: does not check if user already exists with the given email) */
    verifyValidSignup: SignupValidity
}

export type QueryGetCompaniesArgs = {
    limit?: InputMaybe<Scalars['Int']>
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetCompanyPolicyByIdpArgs = {
    companyIdpId: Scalars['String']
    idpType: IdpType
}

export type QueryGetCompanyTermsOfServiceArgs = {
    companyId: Scalars['UUID']
}

export type QueryGetIdpConfigsArgs = {
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
    idpTypeAllowlist?: InputMaybe<Array<IdpType>>
    limit?: InputMaybe<Scalars['Int']>
    name: Scalars['String']
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetIdpConfigsByCompanyIdArgs = {
    companyId: Scalars['UUID']
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
    idpTypeAllowlist?: InputMaybe<Array<IdpType>>
    limit?: InputMaybe<Scalars['Int']>
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetIdpConfigsByEmailArgs = {
    email: Scalars['String']
    limit?: InputMaybe<Scalars['Int']>
    onlyForExistingIdpProfiles?: InputMaybe<Scalars['Boolean']>
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetIdpConfigsForUserByEmailArgs = {
    email: Scalars['String']
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
    idpTypeAllowlist?: InputMaybe<Array<IdpType>>
    limit?: InputMaybe<Scalars['Int']>
    onlyForExistingIdpProfiles?: InputMaybe<Scalars['Boolean']>
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetMagicLinkArgs = {
    cacheId: Scalars['UUID']
    clientId?: InputMaybe<Scalars['String']>
    userId: Scalars['UUID']
}

export type QueryGetSimilarCompaniesArgs = {
    limit?: InputMaybe<Scalars['Int']>
    name: Scalars['String']
    page?: InputMaybe<Scalars['Int']>
}

export type QueryGetUserPolicyByIdpArgs = {
    companyIdpId: Scalars['String']
    idpType: IdpType
    userIdpId: Scalars['String']
}

export type QueryIsInviteValidArgs = {
    inviteId: Scalars['UUID']
}

export type QueryVerifyValidSignupArgs = {
    input: VerifyValidSignupInput
}

export type SignupCode = {
    __typename?: 'SignupCode'
    code: Scalars['String']
    subscription: UserSubscription
}

export type SignupValidity = {
    __typename?: 'SignupValidity'
    allowed: Scalars['Boolean']
    allowedIdpTypes: Array<IdpType>
    errorCode?: Maybe<ErrorCode>
    signupCode?: Maybe<SignupCode>
}

export type TermsOfServiceOption = {
    __typename?: 'TermsOfServiceOption'
    checkboxRequired: Scalars['Boolean']
    name: Scalars['String']
    readRequired: Scalars['Boolean']
    url: Scalars['String']
}

export type TokenResponse = {
    __typename?: 'TokenResponse'
    token: Scalars['String']
}

/** User's subscription associated with Company. Type renamed as UserSubscription to avoid clash with GraphQL Subscription */
export type UserSubscription = {
    __typename?: 'UserSubscription'
    company: Company
    id: Scalars['UUID']
    isDefault: Scalars['Boolean']
}

export type VerifyValidSignupInput = {
    /** Group code */
    code: Scalars['String']
    /** Company Id */
    companyId?: InputMaybe<Scalars['UUID']>
    /** Potential sign-up email */
    email: Scalars['String']
    /** Referrer Id */
    referrerId?: InputMaybe<Scalars['UUID']>
}

export type GetCountryCodeHeaderQueryVariables = Exact<{ [key: string]: never }>

export type GetCountryCodeHeaderQuery = {
    __typename?: 'Query'
    getCountryCodeHeader?: string | null
}

export type GetCheckboxPolicyQueryVariables = Exact<{
    companyId: Scalars['UUID']
}>

export type GetCheckboxPolicyQuery = {
    __typename?: 'Query'
    getCompanyTermsOfService: Array<{
        __typename?: 'TermsOfServiceOption'
        checkboxRequired: boolean
        name: string
        readRequired: boolean
        url: string
    }>
}

export type GetBrandsQueryVariables = Exact<{ [key: string]: never }>

export type GetBrandsQuery = {
    __typename?: 'Query'
    getCompanies: {
        __typename?: 'CompanyPage'
        itemsPerPage: number
        page: number
        total: number
        items: Array<{
            __typename?: 'Company'
            id: any
            imageUrl?: string | null
            isPublic: boolean
            name: string
            brands: Array<{
                __typename?: 'Brand'
                isPublic: boolean
                name: string
                imageUrl?: string | null
            }>
        }>
    }
}

export type GetSuggestedCompaniesQueryVariables = Exact<{
    name: Scalars['String']
}>

export type GetSuggestedCompaniesQuery = {
    __typename?: 'Query'
    getSimilarCompanies: {
        __typename?: 'CompanySearchResultPage'
        total: number
        items: Array<{
            __typename?: 'CompanySearchResult'
            quality: number
            result: {
                __typename?: 'Company'
                name: string
                imageUrl?: string | null
                brands: Array<{ __typename?: 'Brand'; name: string }>
            }
        }>
    }
}

export type GetIdpConfigsQueryVariables = Exact<{
    name: Scalars['String']
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
}>

export type GetIdpConfigsQuery = {
    __typename?: 'Query'
    getIdpConfigs: {
        __typename?: 'IdpConfigPage'
        total: number
        items: Array<{
            __typename?: 'IdpConfig'
            companyId: any
            configuration: string
            emailAllowList: Array<string>
            enabled: boolean
            id: any
            idpType: string
            loginMethod: string
        }>
    }
}

export type GetIdpConfigsByCompanyIdQueryVariables = Exact<{
    companyId: Scalars['UUID']
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
}>

export type GetIdpConfigsByCompanyIdQuery = {
    __typename?: 'Query'
    getIdpConfigsByCompanyId: {
        __typename?: 'IdpConfigPage'
        total: number
        items: Array<{
            __typename?: 'IdpConfig'
            companyId: any
            configuration: string
            emailAllowList: Array<string>
            enabled: boolean
            id: any
            idpType: string
            loginMethod: string
        }>
    }
}

export type GetIdpConfigsForUserByEmailQueryVariables = Exact<{
    email: Scalars['String']
    onlyForExistingIdpProfiles?: InputMaybe<Scalars['Boolean']>
    idpConfigFilters?: InputMaybe<IdpConfigFiltersInput>
}>

export type GetIdpConfigsForUserByEmailQuery = {
    __typename?: 'Query'
    getIdpConfigsForUserByEmail: {
        __typename?: 'IdpConfigsForUserPage'
        itemsPerPage: number
        page: number
        total: number
        userIdpTypes: Array<IdpType>
        items: Array<{
            __typename?: 'IdpConfig'
            companyId: any
            configuration: string
            emailAllowList: Array<string>
            enabled: boolean
            id: any
            idpType: string
            loginMethod: string
        }>
    }
}

export type MagicLinkMutationVariables = Exact<{
    input: MagicLinkRequestInput
}>

export type MagicLinkMutation = { __typename?: 'Mutation'; magicLink: boolean }

export type GetMagicLinkQueryVariables = Exact<{
    userId: Scalars['UUID']
    cacheId: Scalars['UUID']
    clientId?: InputMaybe<Scalars['String']>
}>

export type GetMagicLinkQuery = {
    __typename?: 'Query'
    getMagicLink: {
        __typename?: 'MagicLinkCacheResponse'
        cacheId: any
        expiration?: any | null
        magicLink?: string | null
        redirectUrl?: string | null
        userId: any
    }
}

export type IsInviteValidQueryVariables = Exact<{
    inviteId: Scalars['UUID']
}>

export type IsInviteValidQuery = {
    __typename?: 'Query'
    isInviteValid: boolean
}

export type VerifyEmailAndSignUpValidQueryVariables = Exact<{
    email: Scalars['String']
    onlyForExistingIdpProfiles?: InputMaybe<Scalars['Boolean']>
    input: VerifyValidSignupInput
}>

export type VerifyEmailAndSignUpValidQuery = {
    __typename?: 'Query'
    verifyValidSignup: {
        __typename?: 'SignupValidity'
        allowed: boolean
        errorCode?: ErrorCode | null
    }
    getIdpConfigsForUserByEmail: {
        __typename: 'IdpConfigsForUserPage'
        userIdpTypes: Array<IdpType>
        items: Array<{
            __typename: 'IdpConfig'
            companyId: any
            configuration: string
            emailAllowList: Array<string>
            enabled: boolean
            id: any
            idpType: string
            loginMethod: string
        }>
    }
}

export const GetCountryCodeHeaderDocument = gql`
    query GetCountryCodeHeader {
        getCountryCodeHeader
    }
`

/**
 * __useGetCountryCodeHeaderQuery__
 *
 * To run a query within a React component, call `useGetCountryCodeHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryCodeHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryCodeHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryCodeHeaderQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetCountryCodeHeaderQuery,
        GetCountryCodeHeaderQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetCountryCodeHeaderQuery,
        GetCountryCodeHeaderQueryVariables
    >(GetCountryCodeHeaderDocument, options)
}
export function useGetCountryCodeHeaderLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCountryCodeHeaderQuery,
        GetCountryCodeHeaderQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetCountryCodeHeaderQuery,
        GetCountryCodeHeaderQueryVariables
    >(GetCountryCodeHeaderDocument, options)
}
export type GetCountryCodeHeaderQueryHookResult = ReturnType<
    typeof useGetCountryCodeHeaderQuery
>
export type GetCountryCodeHeaderLazyQueryHookResult = ReturnType<
    typeof useGetCountryCodeHeaderLazyQuery
>
export type GetCountryCodeHeaderQueryResult = Apollo.QueryResult<
    GetCountryCodeHeaderQuery,
    GetCountryCodeHeaderQueryVariables
>
export const GetCheckboxPolicyDocument = gql`
    query GetCheckboxPolicy($companyId: UUID!) {
        getCompanyTermsOfService(companyId: $companyId) {
            checkboxRequired
            name
            readRequired
            url
        }
    }
`

/**
 * __useGetCheckboxPolicyQuery__
 *
 * To run a query within a React component, call `useGetCheckboxPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckboxPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckboxPolicyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCheckboxPolicyQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCheckboxPolicyQuery,
        GetCheckboxPolicyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetCheckboxPolicyQuery,
        GetCheckboxPolicyQueryVariables
    >(GetCheckboxPolicyDocument, options)
}
export function useGetCheckboxPolicyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCheckboxPolicyQuery,
        GetCheckboxPolicyQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetCheckboxPolicyQuery,
        GetCheckboxPolicyQueryVariables
    >(GetCheckboxPolicyDocument, options)
}
export type GetCheckboxPolicyQueryHookResult = ReturnType<
    typeof useGetCheckboxPolicyQuery
>
export type GetCheckboxPolicyLazyQueryHookResult = ReturnType<
    typeof useGetCheckboxPolicyLazyQuery
>
export type GetCheckboxPolicyQueryResult = Apollo.QueryResult<
    GetCheckboxPolicyQuery,
    GetCheckboxPolicyQueryVariables
>
export const GetBrandsDocument = gql`
    query getBrands {
        getCompanies(limit: 1000) {
            itemsPerPage
            items {
                brands {
                    isPublic
                    name
                    imageUrl
                }
                id
                imageUrl
                isPublic
                name
            }
            page
            total
        }
    }
`

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrandsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBrandsQuery,
        GetBrandsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(
        GetBrandsDocument,
        options
    )
}
export function useGetBrandsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBrandsQuery,
        GetBrandsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(
        GetBrandsDocument,
        options
    )
}
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>
export type GetBrandsLazyQueryHookResult = ReturnType<
    typeof useGetBrandsLazyQuery
>
export type GetBrandsQueryResult = Apollo.QueryResult<
    GetBrandsQuery,
    GetBrandsQueryVariables
>
export const GetSuggestedCompaniesDocument = gql`
    query getSuggestedCompanies($name: String!) {
        getSimilarCompanies(name: $name) {
            items {
                quality
                result {
                    name
                    brands {
                        name
                    }
                    imageUrl
                }
            }
            total
        }
    }
`

/**
 * __useGetSuggestedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSuggestedCompaniesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSuggestedCompaniesQuery,
        GetSuggestedCompaniesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetSuggestedCompaniesQuery,
        GetSuggestedCompaniesQueryVariables
    >(GetSuggestedCompaniesDocument, options)
}
export function useGetSuggestedCompaniesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSuggestedCompaniesQuery,
        GetSuggestedCompaniesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetSuggestedCompaniesQuery,
        GetSuggestedCompaniesQueryVariables
    >(GetSuggestedCompaniesDocument, options)
}
export type GetSuggestedCompaniesQueryHookResult = ReturnType<
    typeof useGetSuggestedCompaniesQuery
>
export type GetSuggestedCompaniesLazyQueryHookResult = ReturnType<
    typeof useGetSuggestedCompaniesLazyQuery
>
export type GetSuggestedCompaniesQueryResult = Apollo.QueryResult<
    GetSuggestedCompaniesQuery,
    GetSuggestedCompaniesQueryVariables
>
export const GetIdpConfigsDocument = gql`
    query GetIdpConfigs(
        $name: String!
        $idpConfigFilters: IdpConfigFiltersInput
    ) {
        getIdpConfigs(name: $name, idpConfigFilters: $idpConfigFilters) {
            items {
                companyId
                configuration
                emailAllowList
                enabled
                id
                idpType
                loginMethod
            }
            total
        }
    }
`

/**
 * __useGetIdpConfigsQuery__
 *
 * To run a query within a React component, call `useGetIdpConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdpConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdpConfigsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      idpConfigFilters: // value for 'idpConfigFilters'
 *   },
 * });
 */
export function useGetIdpConfigsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIdpConfigsQuery,
        GetIdpConfigsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetIdpConfigsQuery, GetIdpConfigsQueryVariables>(
        GetIdpConfigsDocument,
        options
    )
}
export function useGetIdpConfigsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIdpConfigsQuery,
        GetIdpConfigsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetIdpConfigsQuery, GetIdpConfigsQueryVariables>(
        GetIdpConfigsDocument,
        options
    )
}
export type GetIdpConfigsQueryHookResult = ReturnType<
    typeof useGetIdpConfigsQuery
>
export type GetIdpConfigsLazyQueryHookResult = ReturnType<
    typeof useGetIdpConfigsLazyQuery
>
export type GetIdpConfigsQueryResult = Apollo.QueryResult<
    GetIdpConfigsQuery,
    GetIdpConfigsQueryVariables
>
export const GetIdpConfigsByCompanyIdDocument = gql`
    query GetIdpConfigsByCompanyId(
        $companyId: UUID!
        $idpConfigFilters: IdpConfigFiltersInput
    ) {
        getIdpConfigsByCompanyId(
            companyId: $companyId
            idpConfigFilters: $idpConfigFilters
        ) {
            items {
                companyId
                configuration
                emailAllowList
                enabled
                id
                idpType
                loginMethod
            }
            total
        }
    }
`

/**
 * __useGetIdpConfigsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetIdpConfigsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdpConfigsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdpConfigsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      idpConfigFilters: // value for 'idpConfigFilters'
 *   },
 * });
 */
export function useGetIdpConfigsByCompanyIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIdpConfigsByCompanyIdQuery,
        GetIdpConfigsByCompanyIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetIdpConfigsByCompanyIdQuery,
        GetIdpConfigsByCompanyIdQueryVariables
    >(GetIdpConfigsByCompanyIdDocument, options)
}
export function useGetIdpConfigsByCompanyIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIdpConfigsByCompanyIdQuery,
        GetIdpConfigsByCompanyIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetIdpConfigsByCompanyIdQuery,
        GetIdpConfigsByCompanyIdQueryVariables
    >(GetIdpConfigsByCompanyIdDocument, options)
}
export type GetIdpConfigsByCompanyIdQueryHookResult = ReturnType<
    typeof useGetIdpConfigsByCompanyIdQuery
>
export type GetIdpConfigsByCompanyIdLazyQueryHookResult = ReturnType<
    typeof useGetIdpConfigsByCompanyIdLazyQuery
>
export type GetIdpConfigsByCompanyIdQueryResult = Apollo.QueryResult<
    GetIdpConfigsByCompanyIdQuery,
    GetIdpConfigsByCompanyIdQueryVariables
>
export const GetIdpConfigsForUserByEmailDocument = gql`
    query GetIdpConfigsForUserByEmail(
        $email: String!
        $onlyForExistingIdpProfiles: Boolean
        $idpConfigFilters: IdpConfigFiltersInput
    ) {
        getIdpConfigsForUserByEmail(
            email: $email
            onlyForExistingIdpProfiles: $onlyForExistingIdpProfiles
            idpConfigFilters: $idpConfigFilters
        ) {
            items {
                companyId
                configuration
                emailAllowList
                enabled
                id
                idpType
                loginMethod
            }
            itemsPerPage
            page
            total
            userIdpTypes
        }
    }
`

/**
 * __useGetIdpConfigsForUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetIdpConfigsForUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdpConfigsForUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdpConfigsForUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      onlyForExistingIdpProfiles: // value for 'onlyForExistingIdpProfiles'
 *      idpConfigFilters: // value for 'idpConfigFilters'
 *   },
 * });
 */
export function useGetIdpConfigsForUserByEmailQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetIdpConfigsForUserByEmailQuery,
        GetIdpConfigsForUserByEmailQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetIdpConfigsForUserByEmailQuery,
        GetIdpConfigsForUserByEmailQueryVariables
    >(GetIdpConfigsForUserByEmailDocument, options)
}
export function useGetIdpConfigsForUserByEmailLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetIdpConfigsForUserByEmailQuery,
        GetIdpConfigsForUserByEmailQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetIdpConfigsForUserByEmailQuery,
        GetIdpConfigsForUserByEmailQueryVariables
    >(GetIdpConfigsForUserByEmailDocument, options)
}
export type GetIdpConfigsForUserByEmailQueryHookResult = ReturnType<
    typeof useGetIdpConfigsForUserByEmailQuery
>
export type GetIdpConfigsForUserByEmailLazyQueryHookResult = ReturnType<
    typeof useGetIdpConfigsForUserByEmailLazyQuery
>
export type GetIdpConfigsForUserByEmailQueryResult = Apollo.QueryResult<
    GetIdpConfigsForUserByEmailQuery,
    GetIdpConfigsForUserByEmailQueryVariables
>
export const MagicLinkDocument = gql`
    mutation MagicLink($input: MagicLinkRequestInput!) {
        magicLink(input: $input)
    }
`
export type MagicLinkMutationFn = Apollo.MutationFunction<
    MagicLinkMutation,
    MagicLinkMutationVariables
>

/**
 * __useMagicLinkMutation__
 *
 * To run a mutation, you first call `useMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [magicLinkMutation, { data, loading, error }] = useMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMagicLinkMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MagicLinkMutation,
        MagicLinkMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<MagicLinkMutation, MagicLinkMutationVariables>(
        MagicLinkDocument,
        options
    )
}
export type MagicLinkMutationHookResult = ReturnType<
    typeof useMagicLinkMutation
>
export type MagicLinkMutationResult = Apollo.MutationResult<MagicLinkMutation>
export type MagicLinkMutationOptions = Apollo.BaseMutationOptions<
    MagicLinkMutation,
    MagicLinkMutationVariables
>
export const GetMagicLinkDocument = gql`
    query GetMagicLink($userId: UUID!, $cacheId: UUID!, $clientId: String) {
        getMagicLink(userId: $userId, cacheId: $cacheId, clientId: $clientId) {
            cacheId
            expiration
            magicLink
            redirectUrl
            userId
        }
    }
`

/**
 * __useGetMagicLinkQuery__
 *
 * To run a query within a React component, call `useGetMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMagicLinkQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      cacheId: // value for 'cacheId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetMagicLinkQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMagicLinkQuery,
        GetMagicLinkQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetMagicLinkQuery, GetMagicLinkQueryVariables>(
        GetMagicLinkDocument,
        options
    )
}
export function useGetMagicLinkLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMagicLinkQuery,
        GetMagicLinkQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetMagicLinkQuery, GetMagicLinkQueryVariables>(
        GetMagicLinkDocument,
        options
    )
}
export type GetMagicLinkQueryHookResult = ReturnType<
    typeof useGetMagicLinkQuery
>
export type GetMagicLinkLazyQueryHookResult = ReturnType<
    typeof useGetMagicLinkLazyQuery
>
export type GetMagicLinkQueryResult = Apollo.QueryResult<
    GetMagicLinkQuery,
    GetMagicLinkQueryVariables
>
export const IsInviteValidDocument = gql`
    query isInviteValid($inviteId: UUID!) {
        isInviteValid(inviteId: $inviteId)
    }
`

/**
 * __useIsInviteValidQuery__
 *
 * To run a query within a React component, call `useIsInviteValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsInviteValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsInviteValidQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useIsInviteValidQuery(
    baseOptions: Apollo.QueryHookOptions<
        IsInviteValidQuery,
        IsInviteValidQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<IsInviteValidQuery, IsInviteValidQueryVariables>(
        IsInviteValidDocument,
        options
    )
}
export function useIsInviteValidLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        IsInviteValidQuery,
        IsInviteValidQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<IsInviteValidQuery, IsInviteValidQueryVariables>(
        IsInviteValidDocument,
        options
    )
}
export type IsInviteValidQueryHookResult = ReturnType<
    typeof useIsInviteValidQuery
>
export type IsInviteValidLazyQueryHookResult = ReturnType<
    typeof useIsInviteValidLazyQuery
>
export type IsInviteValidQueryResult = Apollo.QueryResult<
    IsInviteValidQuery,
    IsInviteValidQueryVariables
>
export const VerifyEmailAndSignUpValidDocument = gql`
    query verifyEmailAndSignUpValid(
        $email: String!
        $onlyForExistingIdpProfiles: Boolean
        $input: VerifyValidSignupInput!
    ) {
        verifyValidSignup(input: $input) {
            allowed
            errorCode
        }
        getIdpConfigsForUserByEmail(
            email: $email
            onlyForExistingIdpProfiles: $onlyForExistingIdpProfiles
        ) {
            items {
                companyId
                configuration
                emailAllowList
                enabled
                id
                idpType
                loginMethod
                __typename
            }
            userIdpTypes
            __typename
        }
    }
`

/**
 * __useVerifyEmailAndSignUpValidQuery__
 *
 * To run a query within a React component, call `useVerifyEmailAndSignUpValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailAndSignUpValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyEmailAndSignUpValidQuery({
 *   variables: {
 *      email: // value for 'email'
 *      onlyForExistingIdpProfiles: // value for 'onlyForExistingIdpProfiles'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailAndSignUpValidQuery(
    baseOptions: Apollo.QueryHookOptions<
        VerifyEmailAndSignUpValidQuery,
        VerifyEmailAndSignUpValidQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        VerifyEmailAndSignUpValidQuery,
        VerifyEmailAndSignUpValidQueryVariables
    >(VerifyEmailAndSignUpValidDocument, options)
}
export function useVerifyEmailAndSignUpValidLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        VerifyEmailAndSignUpValidQuery,
        VerifyEmailAndSignUpValidQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        VerifyEmailAndSignUpValidQuery,
        VerifyEmailAndSignUpValidQueryVariables
    >(VerifyEmailAndSignUpValidDocument, options)
}
export type VerifyEmailAndSignUpValidQueryHookResult = ReturnType<
    typeof useVerifyEmailAndSignUpValidQuery
>
export type VerifyEmailAndSignUpValidLazyQueryHookResult = ReturnType<
    typeof useVerifyEmailAndSignUpValidLazyQuery
>
export type VerifyEmailAndSignUpValidQueryResult = Apollo.QueryResult<
    VerifyEmailAndSignUpValidQuery,
    VerifyEmailAndSignUpValidQueryVariables
>

export interface PossibleTypesResultData {
    possibleTypes: {
        [key: string]: string[]
    }
}
const result: PossibleTypesResultData = {
    possibleTypes: {}
}
export default result
